const _excluded = ["size"];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
var FlagAu16 = function FlagAu16(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("path", {
      d: "M.5 3.9a1.4 1.4 0 0 1 1.4-1.4h12.2a1.4 1.4 0 0 1 1.4 1.4v7.55a1.4 1.4 0 0 1-1.4 1.4H1.9a1.4 1.4 0 0 1-1.4-1.4V3.9z",
      fill: "#00008B",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "m4.9 11.351-.65-.684-.65.684.129-.935-.941-.082.812-.482-.523-.787.884.334.289-.899.29.9.883-.335-.523.787.812.482-.94.082.129.935zm7.16.126-.31-.326-.31.326.062-.446-.448-.039.386-.23-.248-.374.42.16.138-.429.138.428.42-.159-.248.375.386.23-.448.038.062.446zm-2.5-3.958-.31-.327-.31.327.062-.446-.448-.04.386-.229-.248-.374.42.159.138-.428.138.428.42-.16-.249.375.387.23-.448.039.062.446zm2.5-2.709-.31-.326-.31.326.062-.445-.448-.04.386-.229-.248-.375.42.16.138-.429.138.429.42-.16-.248.375.386.23-.448.039.062.445zm2.222 2.042-.31-.326-.31.326.062-.446-.448-.039.387-.23-.25-.374.421.16.138-.429.138.428.42-.159-.248.375.387.23-.449.038.062.446zm-1.777 1.402.069-.28-.22-.186.287-.021.109-.267.109.267.287.02-.22.187.069.28-.245-.152-.245.152zM3.349 5 .5 6.9v.6h.901L4.25 5.601l2.849 1.9h.9v-.602L5.152 5 8 3.101v-.6h-.901L4.25 4.398 1.488 2.555l-.242.105-.266.176-.195.219-.112.162L3.35 5z",
      fill: "#fff",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M.5 7.5 3 5.833h.559L.951 7.5H.5zm4.441-3.333 2.5-1.667H8L5.5 4.167h-.559zM8 7.5 5.5 5.833h.559L8 7.127V7.5zM3 4.167h-.559L.777 3.057l.207-.229L3 4.167z",
      fill: "red",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M4.25 2.5v5-5zM.5 5H8z",
      fill: "#000",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.083 5.834V7.5H3.417V5.834H.5V4.167h2.917V2.5h1.666v1.667H8v1.667H5.083z",
      fill: "#fff",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M4.25 2.5v5-5zM.5 5H8z",
      fill: "#000",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.75 5.5v2h-1v-2H.5v-1h3.25v-2h1v2H8v1H4.75z",
      fill: "red",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.882 2h12.236C15.158 2 16 2.843 16 3.882v7.53c0 1.04-.843 1.882-1.882 1.882H1.882A1.882 1.882 0 0 1 0 11.412v-7.53C0 2.842.843 2 1.882 2zm0 .47c-.78 0-1.411.633-1.411 1.412v7.53c0 .78.632 1.411 1.411 1.411h12.236a1.41 1.41 0 0 0 1.411-1.411v-7.53a1.41 1.41 0 0 0-1.411-1.411H1.882z",
      fill: "#D8DDE1",
    })
  );
};
FlagAu16.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
const sizeMap = {
  16: FlagAu16,
};
export function FlagAu(_ref) {
  let { size = "16" } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const Icon = sizeMap[size] || sizeMap["16"];
  if (
    process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    !sizeMap[size]
  ) {
    throw new Error(
      "The '".concat(
        size,
        "' size is not supported by the 'FlagAu' icon. Please use one of the available sizes: '16'."
      )
    );
  }
  return /*#__PURE__*/ React.createElement(Icon, props);
}
